// Include jQuery plugins
//require('jquery.sample');

// Import non-jQuery modules
const InfiniteScroll = require('infinite-scroll');
const imagesLoaded = require('imagesloaded');
const debounce = require('debounce');

InfiniteScroll.imagesLoaded = imagesLoaded;

// Define wp_localize_script handles
/* global Fancybox, artistarena, gform, handorgel, FullCalendar, fbq */

(function($) {
    const wntrTheme = {
        body: $('body'),
        html: $('html'),
        document: $(document),
        currentSignupStep: 1,
        successColor: '#22F65E',
        failColor: '#FF9736',
        scrollTimeout: null,
        throttle: 50,

        /**
         * Initialise theme JS on page load
         */
        init: function() {
            // Do we have JS?
            $('html').removeClass('no-js');

            // Automatically call all methods that start with __, in the order they're defined
            for(const prop in wntrTheme) {
                if(prop.startsWith('__') && typeof wntrTheme[prop] === 'function') {
                    wntrTheme[prop].call();
                }
            }
        },

        /**
         * Remove Aelia currency param from URL
         */
        __removeCurrencyParamFromUrl: () => {
            const url = new URL(window.location.href);
            const params = new URLSearchParams(url.search);

            if (params.has('aelia_cs_currency')) {
                params.delete('aelia_cs_currency');
                const newUrl = url.origin + url.pathname + '?' + params.toString();
                window.history.replaceState({}, '', newUrl);
            }
        },

        /**
         * Read more about artist
         */
        __readMoreAboutArtist: () => {
            const btn = wntrTheme.body.find('.about-artist__show-more');
            const text = wntrTheme.body.find('.about-artist__text');

            btn.on('click', function() {
                $(this).toggleClass('is-active');
                $(text).toggleClass('is-active');
            });
        },

        /**
         * Reorder artworks
         */
        __reorderArtworks: () => {
            // Handle artwork names
            wntrTheme.body.on('click', '.ginput_container_artist_images--card--has-input-buttons button', function() {
                const $btn = $(this);
                const data = {
                    'action': 'reorder_artist_artworks',
                    'data': {
                        'image_url': $btn.closest('.ginput_container_artist_images').data('url'),
                        'move_to': $btn.data('move-to'),
                        'move_from': $btn.data('move-from')
                    }
                };

                $.ajax({
                    url: artistarena.ajax_url,
                    data: data,
                    type: 'POST',
                    dataType: 'json',
                    beforeSend: function() {
                        wntrTheme.fullpageSpinner(true);
                    },
                    success: function(response) {
                        if(response.success) {
                            $("#field_5_5").load(location.href + " #field_5_5>*", function() {
                                $.toast({
                                    text: response.data.msg,
                                    bgColor: wntrTheme.successColor,
                                    textColor: '#000000',
                                    position: 'top-right'
                                });
                                wntrTheme.fullpageSpinner(false);
                            });
                        } else {
                            $.toast({
                                text: response.data,
                                bgColor: wntrTheme.failColor,
                                textColor: '#000000',
                                position: 'top-right'
                            });
                            wntrTheme.fullpageSpinner(false);
                        }

                    },
                    fail: function() {
                        wntrTheme.fullpageSpinner(false);
                    }
                });
            });
        },


        /**
         * Toggle manually sold artworks
         */
        __toggleManuallySoldArtworks: () => {
            wntrTheme.body.on('change', '#toggle-manually-sold', function() {
                const $cb = $(this);

                if($cb.is(':checked')) {
                    wntrTheme.body.addClass('hide-sold-products');
                } else {
                    wntrTheme.body.removeClass('hide-sold-products');
                }
            });
        },

        /**
         * Mark product as manually sold
         */
        __markProductAsManuallySold: () => {
            wntrTheme.body.find('.dashboard__store-edit-product-popup-mark-as-sold').on('click', function() {
                const productId = $(this).data('product-id');
                const status = $(this).data('status');
                const data = {
                    'action': 'mark_product_as_manually_sold',
                    'data': {
                        'product_id': productId,
                        'status': status
                    }
                };

                $.ajax({
                    url: artistarena.ajax_url,
                    data: data,
                    type: 'POST',
                    dataType: 'json',
                    beforeSend: function() {
                        wntrTheme.fullpageSpinner(true);
                    },
                    success: function(response) {
                        if(response.success) {
                            $.toast({
                                text: 'Product successfully updated, reloading page..',
                                bgColor: wntrTheme.successColor,
                                textColor: '#000000',
                                position: 'top-right'
                            });

                            setTimeout(function() {
                                window.location.href = artistarena.home_url + '/profile/store';
                            }, 500);
                        } else {
                            $.toast({
                                text: response.data,
                                bgColor: wntrTheme.failColor,
                                textColor: '#000000',
                                position: 'top-right'
                            });

                            wntrTheme.fullpageSpinner(false);
                        }
                    },
                    fail: function() {
                        wntrTheme.fullpageSpinner(false);
                    }
                });
            });
        },

        /**
         * Header menu
         */
        __handleHeaderMenu: () => {
            const toggleHeaderButton = wntrTheme.body.find('.header__toggle-menu');
            const toggleHeaderElements = wntrTheme.body.find('.header__toggle-menu, .header__navigation-overlay');
            const toggleSearchElements = wntrTheme.body.find('.header__toggle-search, .header__search-top-back-btn');

            toggleHeaderElements.on('click', function() {
                const $btn = $(this);

                if(wntrTheme.body.hasClass('header--mobile-menu-active')) {
                    wntrTheme.body.removeClass('header--mobile-menu-active');
                    wntrTheme.body.removeClass('body--fixed');
                    $btn.removeClass('is-active');

                    wntrTheme.document.scrollTop(wntrTheme.current_position);
                } else {
                    wntrTheme.body.addClass('header--mobile-menu-active');
                    wntrTheme.body.removeClass('search--active');
                    $btn.addClass('is-active');

                    // Save current position from top
                    wntrTheme.current_position = wntrTheme.document.scrollTop();

                    // SetTimeout till the css animation has ended
                    setTimeout(function() {
                        wntrTheme.body.addClass('body--fixed');
                    }, 200);
                }
            });

            toggleSearchElements.on('click', function() {
                if(wntrTheme.body.hasClass('search--active')) {
                    wntrTheme.body.removeClass('search--active');
                    wntrTheme.body.removeClass('body--fixed');

                    wntrTheme.document.scrollTop(wntrTheme.current_position);
                } else {
                    wntrTheme.body.addClass('search--active');
                    wntrTheme.body.find('.header__search-form .search-field').focus();
                    wntrTheme.body.removeClass('header--mobile-menu-active');
                    toggleHeaderButton.removeClass('is-active');

                    // Save current position from top
                    wntrTheme.current_position = wntrTheme.document.scrollTop();

                    // SetTimeout till the css animation has ended
                    setTimeout(function() {
                        wntrTheme.body.addClass('body--fixed');
                    }, 200);
                }
            });

            $(document).keyup(function(e) {
                if(e.keyCode === 27 && (wntrTheme.body.hasClass('header--mobile-menu-active') || wntrTheme.body.hasClass('search--active'))) {
                    wntrTheme.body.removeClass('header--mobile-menu-active');
                    wntrTheme.body.removeClass('body--fixed');
                    wntrTheme.body.removeClass('search--active');
                    toggleHeaderButton.removeClass('is-active');
                }
            });
        },

        /**
         * Webinars
         */
        __handleWebinars: () => {
            // Toggle webinar tabs
            const $webinar_tabs = wntrTheme.body.find('.webinars__tab');
            const $webinar_content = wntrTheme.body.find('.webinars__container');
            $webinar_tabs.on('click', function() {
                const $tab = $(this);

                $webinar_tabs.removeClass('active');
                $webinar_content.removeClass('active');

                $tab.addClass('active');
                wntrTheme.body.find('.webinars__container[data-type=' + $tab.data('type') + ']').addClass('active');
            });

            // Render calendar
            const $calendar = wntrTheme.body.find('#webinars__calendar');
            if($calendar.length > 0) {
                const calendar = new FullCalendar.Calendar($calendar[0], {
                    initialView: 'dayGridMonth',
                    firstDay: 1,
                    events: $calendar.data('webinars')
                });

                calendar.render();
            }

            wntrTheme.body.on('click', '.fc-day-future .fc-daygrid-day-frame', function() {
                const $frame = $(this);

                if($frame.find('.fc-event-title').length > 0) {
                    const $webinar_title = $frame.find('.fc-event-title').text();
                    const $webinars = $('.webinar h2').filter(function() {
                        return $(this).text().indexOf($webinar_title) >= 0;
                    }).first();

                    if($webinars.length > 0) {
                        $webinar_tabs.removeClass('active');
                        $webinar_content.removeClass('active');

                        wntrTheme.body.find('.webinars__tab[data-type=upcoming]').addClass('active');
                        wntrTheme.body.find('.webinars__container[data-type=upcoming]').addClass('active');

                        setTimeout(function() {
                            $('html,body').animate({ scrollTop: ($($webinars).offset().top - 70) }, 200);
                            $($webinars).closest('.webinar').focus();
                        }, 50);
                    }
                }
            });
        },

        /**
         * Sort E-books
         * TODO: fix sorting pls
         */
        __sortEbooks: () => {
            if(wntrTheme.body.find('.ebooks__wrapper').length > 0) {
                const e_books = wntrTheme.body.find('.ebook');

                wntrTheme.body.on('change', '.ebooks__sorting select', function() {
                    const option_selected = $('option:selected', $(this)).val();

                    if(option_selected.length > 0) {
                        if(option_selected === 'title') {
                            e_books.sort(wntrTheme.compareFirstNames);

                            wntrTheme.body.find('.ebooks__wrapper').html(e_books);
                        } else if(option_selected === 'date') {
                            e_books.sort(function(a, b) {
                                return $(b).data('date') - $(a).data('date');
                            });

                            wntrTheme.body.find('.ebooks__wrapper').html(e_books);
                        }
                    }
                });
            }
        },

        compareFirstNames(a, b) {
            if($(a).data('title') < $(b).data('title')) {
                return -1;
            }
            if($(a).data('title') > $(b).data('title')) {
                return 1;
            }

            return 0;
        },

        /**
         * Do match height
         */
        __doMatchHeight: () => {
            wntrTheme.body.find('.ebook__title').matchHeight();
            wntrTheme.body.find('.ebook__description').matchHeight();
            wntrTheme.body.find('.dashboard__resource-title').matchHeight();
            wntrTheme.body.find('.dashboard__resource-description').matchHeight();
            wntrTheme.body.find('.help-center__card-heading').matchHeight();
            wntrTheme.body.find('.help-center__card-content').matchHeight();
        },

        /**
         * Filter buddies
         * TODO: move this to PHP
         */
        __filterBuddies: () => {
            if(wntrTheme.body.find('.buddies__item').length > 0) {
                // Build array of buddies
                const buddies = [];
                $.each(wntrTheme.body.find('.buddies__item'), function() {
                    const $buddy = $(this);

                    const mediums = [];
                    $.each($buddy.find('.buddies__medium'), function() {
                        mediums.push($(this).text());
                    });

                    buddies.push({
                        'artist_name': $buddy.data('artist-name'),
                        'name': $buddy.find('.buddies__name').text().toLowerCase().replace(/\s/g, ''),
                        'mediums': mediums,
                        'is_match': $buddy.data('is-match')
                    });
                });

                // Text search
                wntrTheme.body.on('keyup change paste', '.buddies__filter-name input', function() {
                    const $input = $(this);
                    const search_text = $input.val();

                    if(search_text.length > 0) {
                        $.each(buddies, function(el, buddy) {
                            if(buddy.name.includes(search_text)) {
                                wntrTheme.body.find('.buddies__item[data-artist-name="' + buddy.artist_name + '"]').removeClass('text-search--hidden');
                            } else {
                                wntrTheme.body.find('.buddies__item[data-artist-name="' + buddy.artist_name + '"]').addClass('text-search--hidden');
                            }
                        });
                    } else {
                        wntrTheme.body.find('.buddies__item').removeClass('text-search--hidden');
                    }

                    checkIfAnyBuddiesIsVisible();
                });

                // Matched buddy filter
                wntrTheme.body.on('change', '.buddies__filter-matches input', function() {
                    const $cb = $(this);

                    if($cb.is(':checked')) {
                        $.each(buddies, function(el, buddy) {
                            if(!buddy.is_match) {
                                wntrTheme.body.find('.buddies__item[data-artist-name="' + buddy.artist_name + '"]').addClass('is-buddy--hidden');
                            }
                        });
                    } else {
                        wntrTheme.body.find('.buddies__item').removeClass('is-buddy--hidden');
                    }

                    checkIfAnyBuddiesIsVisible();
                });

                // Medium filter
                wntrTheme.body.on('change', '.buddies__filter-medium select', function() {
                    const option_selected = $('option:selected', $(this)).val();

                    if(option_selected.length > 0) {
                        $.each(buddies, function(el, buddy) {
                            if(buddy.mediums.includes(option_selected)) {
                                wntrTheme.body.find('.buddies__item[data-artist-name="' + buddy.artist_name + '"]').removeClass('medium--hidden');
                            } else {
                                wntrTheme.body.find('.buddies__item[data-artist-name="' + buddy.artist_name + '"]').addClass('medium--hidden');
                            }
                        });
                    } else {
                        wntrTheme.body.find('.buddies__item').removeClass('medium--hidden');
                    }

                    checkIfAnyBuddiesIsVisible();
                });
            }

            // Show notification if nothing matches your search
            function checkIfAnyBuddiesIsVisible() {
                const $no_matches_notification = wntrTheme.body.find('.notification__message-buddies');

                if(wntrTheme.body.find('.buddies__item:visible').length > 0) {
                    $no_matches_notification.hide();
                } else {
                    $no_matches_notification.css('display', 'inline-block');
                }
            }
        },

        /**
         * Art Stories Archive
         * Handle infinite scroll and category filtering
         */
        __artStoriesArchive: (loadNextPage = false) => {
            const art_stories = wntrTheme.body.find('.art-stories__inner--all');

            if(art_stories.length > 0) {
                const heading = art_stories.find('.art-stories__heading').text();

                // AJAXify category links
                wntrTheme.body.find('.art-stories__categories a').on('click', function(e) {
                    e.preventDefault();

                    wntrTheme.fullpageSpinner(true);

                    const link = $(this);

                    // Fetch updated DOM content from the selected category
                    art_stories.load(
                        link.attr('href') + ' #' + art_stories.find('.art-stories__inner').attr('id'),
                        () => {
                            art_stories.find('.art-stories__heading').text(heading);

                            // Re-init filters/infinite scroll with the newly loaded DOM content
                            wntrTheme.__artStoriesArchive(true);

                            wntrTheme.fullpageSpinner(false);
                        }
                    );

                    return false;
                });

                // Enable infinite scroll if there are multiple pages
                if(wntrTheme.body.find('.art-stories__pagination .next').length > 0) {
                    const infiniteScroll = new InfiniteScroll(wntrTheme.body.find('.art-stories__content')[0], {
                        path: '.art-stories__pagination .next',
                        append: '.art-stories__content .art-story',
                        history: false,
                        status: '.art-stories__page-load-status',
                        hideNav: '.art-stories__pagination'
                    });

                    // Immediately load next page
                    // Used after filtering by category since in some cases, after filtering,
                    // the user will be at the bottom of the page and would have to scroll up
                    // and then down to load the next page. This loads the next one for them
                    // automatically after filtering.
                    if(loadNextPage) {
                        infiniteScroll.loadNextPage();
                    }
                }
            }
        },

        /**
         * Portfolios Archive
         * Handle infinite scroll and genre/technique filtering
         */
        __portfoliosArchive: (loadNextPage = false) => {
            const portfolio_archive = wntrTheme.body.find('.page-section-portfolio_archive');

            if(portfolio_archive.length > 0) {
                const inner = wntrTheme.body.find('.portfolio-archive__inner');
                const content = wntrTheme.body.find('.portfolio-archive__content')[0];

                // AJAXify genre/technique links
                portfolio_archive.find('.portfolio-archive__filters a').on('click', function(e) {
                    e.preventDefault();

                    wntrTheme.fullpageSpinner(true);

                    const link = $(this);

                    // Fetch updated DOM content from the selected category
                    const url = link.attr('href');
                    portfolio_archive.load(
                        url + ' #' + inner.attr('id'),
                        () => {
                            // Re-init filters/infinite scroll with the newly loaded DOM content
                            wntrTheme.__portfoliosArchive(true);

                            history.replaceState({}, '', url);

                            wntrTheme.fullpageSpinner(false);
                        }
                    );

                    return false;
                });

                // Enable infinite scroll if there are multiple pages
                if(wntrTheme.body.find('.portfolio-archive__pagination .next').length > 0) {
                    const infiniteScroll = new InfiniteScroll(content, {
                        path: '.portfolio-archive__pagination .next',
                        append: '.portfolio-archive__portfolio',
                        history: false,
                        status: '.portfolio-archive__page-load-status',
                        hideNav: '.portfolio-archive__pagination'
                    });

                    // Immediately load next page
                    // Used after filtering by category since in some cases, after filtering,
                    // the user will be at the bottom of the page and would have to scroll up
                    // and then down to load the next page. This loads the next one for them
                    // automatically after filtering.
                    if(loadNextPage) {
                        infiniteScroll.loadNextPage();
                    }
                }
            }
        },

        /**
         * Shop Page
         * Handle the masonry grid and infinite scroll
         * Re-used by artist profiles
         */
        __shopPage(reinit) {
            if(wntrTheme.body.find('.shop__archive-products ul').length > 0) {

                // Replace pagination with infinite scroll
                if(wntrTheme.body.find('.woocommerce-pagination').length > 0) {
                    new InfiniteScroll('.shop__archive-products ul', {
                        path: '.woocommerce-pagination .next',
                        append: '.shop__archive-products .shop__archive-product-list-item',
                        history: 'replace',
                        status: '.shop__archive-load-status',
                        hideNav: '.woocommerce-pagination',
                        loadOnScroll: true,
                        scrollThreshold: 200,
                        button: '.view-more-button',
                    });
                }

                // Update layout when products are filtered
                $(document).ajaxStop(function() {
                    wntrTheme.__shopPage(true);
                });

                // Toggle filters on mobile
                if(!reinit) {
                    const filters = wntrTheme.body.find('.shop__archive-filters');
                    const filterNotes = filters.find('.wcpf-note-list');
                    const filtersBtn = wntrTheme.body.find('.shop__archive-menu-btn--filters');

                    filtersBtn.on('click', function() {
                        filters.toggleClass('shop__archive-filters--visible');
                        $(this).toggleClass('shop__archive-menu-btn--active');

                        // Pre-open handorgel
                        const handorgel = filters[0];
                        if(handorgel.handorgel && handorgel.handorgel.folds && handorgel.handorgel.folds[0]) {
                            handorgel.handorgel.folds[0].open(false);

                            // Close the modal if the handorgel is closed
                            handorgel.handorgel.on('fold:close', () => {
                                filtersBtn.trigger('click');
                            });
                        }
                    });

                    wntrTheme.body.find('.shop__archive-menu-btn--categories').on('click', function() {
                        wntrTheme.body.find('.shop__archive-categories').toggleClass('shop__archive-categories--visible');
                        $(this).toggleClass('shop__archive-menu-btn--active');
                    });

                    const filterCount = wntrTheme.body.find('.shop__archive-filters-count');

                    if(filterNotes.length > 0) {
                        // Count number of selected filters dynamically and update the number shown
                        const observer = new MutationObserver(() => {
                            const count = filterNotes.children().length;
                            filterCount.text(count > 0 ? ('(' + count + ')') : '');
                            filtersBtn.toggleClass('shop__archive-menu-btn--filters-selected', count > 0);
                        });

                        observer.observe(filterNotes[0], {
                            childList: true
                        });
                    }
                }

                // Hide filter mobile when clear or filter button is clicked
                wntrTheme.body.find('.shop__archive-filters .wcpf-button').on('click', function() {
                    wntrTheme.body.find('.shop__archive-filters').removeClass('shop__archive-filters--visible');
                });
            }
        },

        /**
         * Do handorgel
         */
        __doHandorgel: () => {
            if(wntrTheme.body.find('.handorgel').length > 0) {
                $.each(wntrTheme.body.find('.handorgel'), function() {
                    const $handorgel = $(this);
                    new handorgel($handorgel[0], {});
                });
            }
        },

        /**
         * Art stories
         */
        __artStoriesSection: () => {
            const artStories = wntrTheme.body.find('.page-section-single-product--art-stories .art-stories__content');

            const initSlider = () => {
                artStories.slick({
                    dots: false,
                    infinite: false,
                    arrows: false,
                    speed: 300,
                    swipeToSlide: true,
                    mobileFirst: true,
                    slidesToShow: 1.5,
                    adaptiveHeight: true,
                    touchThreshold: 30,
                    responsive: [
                        {
                            breakpoint: 720,
                            settings: {
                                slidesToShow: 3.5
                            }
                        },
                    ]
                });

                artStories.on('wheel', (function(e) {
                    const $slider = $(this);
                    if(!wntrTheme.scrollTimeout) {
                        wntrTheme.scrollTimeout = setTimeout(() => {
                            wntrTheme.slideOnScoll(e, $slider);
                            wntrTheme.scrollTimeout = null;
                        }, wntrTheme.throttle);
                    }
                }));
            };

            if(artStories.length) {
                $(window).on('resize', debounce(initSlider)).trigger('resize');
            }
        },

        /**
         * Showcase sections
         */
        __showcaseSection: () => {
            const showcases = wntrTheme.body.find('.showcase:not(.showcase--stories)');

            const initShowcase = () => {
                showcases.each(function() {
                    const showcase = $(this);
                    const showcaseInner = showcase.find('.showcase__container-inner');

                    if(!showcase.hasClass('showcase--layout-masonry')) {
                        if((window.innerWidth >= 720 && showcase.hasClass('showcase--layout-auto')) || (showcase.hasClass('showcase--layout-slider'))) {
                            showcaseInner.not('.slick-initialized').slick({
                                dots: false,
                                infinite: false,
                                arrows: false,
                                speed: 300,
                                swipeToSlide: true,
                                mobileFirst: true,
                                slidesToShow: 1.5,
                                adaptiveHeight: true,
                                touchThreshold: 30,
                                responsive: [
                                    {
                                        breakpoint: 720,
                                        settings: {
                                            slidesToShow: 3.5
                                        }
                                    },
                                ]
                            });

                            showcaseInner.on('wheel', (function(e) {
                                const $slider = $(this);
                                if(!wntrTheme.scrollTimeout) {
                                    wntrTheme.scrollTimeout = setTimeout(() => {
                                        wntrTheme.slideOnScoll(e, $slider);
                                        wntrTheme.scrollTimeout = null;
                                    }, wntrTheme.throttle);
                                }
                            }));
                        } else if(showcaseInner.hasClass('slick-initialized')) { // Masonry on mobile
                            showcaseInner.slick('unslick');
                        }
                    }
                });
            };

            if(showcases.length) {
                $(window).on('resize', debounce(initShowcase)).trigger('resize');
            }
        },

        /**
         * Artist profile
         */
        __artistProfile: () => {
            const artistProfileGallery = wntrTheme.body.find('.artist-profile__gallery');

            if(artistProfileGallery.length) {
                artistProfileGallery.slick({
                    dots: false,
                    infinite: false,
                    arrows: false,
                    speed: 300,
                    swipeToSlide: true,
                    mobileFirst: true,
                    slidesToShow: 1.5,
                    adaptiveHeight: true,
                    touchThreshold: 30,
                    responsive: [
                        {
                            breakpoint: 720,
                            settings: {
                                slidesToShow: 2.5
                            }
                        },
                    ]
                });

                artistProfileGallery.on('wheel', (function(e) {
                    const $slider = $(this);
                    if(!wntrTheme.scrollTimeout) {
                        wntrTheme.scrollTimeout = setTimeout(() => {
                            wntrTheme.slideOnScoll(e, $slider);
                            wntrTheme.scrollTimeout = null;
                        }, wntrTheme.throttle);
                    }
                }));
            }
        },

        /**
         * Change slick slide on scroll
         */
        slideOnScoll(e, $slider) {
            if(e.originalEvent.wheelDeltaX < -5) {
                e.preventDefault();
                $slider.slick('slickNext');
            } else if(e.originalEvent.wheelDeltaX > 5) {
                e.preventDefault();
                $slider.slick('slickPrev');
            }
        },

        /**
         * Fancybox settings
         */
        __fancyboxSettings: () => {
            Fancybox.defaults.dragToClose = false;

            Fancybox.bind('[data-fancybox="submit-product__modal"]', {
                keyboard: false,
                on: {
                    shouldClose: function(fancybox, event) {
                        const classList = event && event.target && event.target.classList ? event.target.classList.value : '';

                        if(!classList.includes('is-close')) {
                            return false;
                        }
                    },
                    done: function() {
                        setTimeout(() => {
                            window.history.replaceState('', '', artistarena.home_url + '/profile/store');
                        }, 200);
                    }
                }
            });
        },

        /**
         * Logged in dashboard
         */
        __handleDashboard: () => {
            // Toggle header
            wntrTheme.body.find('.dashboard__header-hamburger .hamburger').on('click', function() {
                const $btn = $(this);

                $btn.closest('.dashboard__header').toggleClass('is-active');
                $btn.toggleClass('is-active');
            });

            // Toggle dashboard tabs
            const $dashboard_tabs = wntrTheme.body.find('.dashboard__portfolio-tab');
            const $dashboard_content = wntrTheme.body.find('.dashboard__portfolio-content-inner');
            $dashboard_tabs.on('click', function() {
                const $tab = $(this);

                $dashboard_tabs.removeClass('active');
                $dashboard_content.removeClass('active');

                $tab.addClass('active');
                wntrTheme.body.find('.dashboard__portfolio-content-inner[data-content=' + $tab.data('tab') + ']').addClass('active');
                wntrTheme.body.find('.dashboard__portfolio-content-inner[data-content=' + $tab.data('tab') + ']').animate({
                    scrollTop: -9999
                }, 0);
                window.history.replaceState('', '', artistarena.home_url + '/profile/portfolio?tab=' + $tab.data('tab'));
            });

            // Remove success message from edit artist form
            if(wntrTheme.body.find('.notification__message--portfolio').length > 0) {
                setTimeout(function() {
                    wntrTheme.body.find('.notification__message--portfolio').fadeOut();
                    const url = new URL(window.location.href);
                    url.searchParams.append('message_viewed', '1');
                    window.history.replaceState('', '', url);
                }, 2000);
            }

            // Handle images
            wntrTheme.body.on('click', '.ginput_container_artist_images-action', function() {
                const $btn = $(this);
                const data = {
                    'action': 'update_artist_images',
                    'data': {
                        'type': $btn.hasClass('ginput_container_artist_images-action--profile-picture') ? 'profile_pictures' : 'artworks',
                        'remove': $btn.hasClass('ginput_container_artist_images-action--remove'),
                        'use': $btn.hasClass('ginput_container_artist_images-action--use'),
                        'image_url': $btn.closest('.ginput_container_artist_images').data('url')
                    }
                };

                $.ajax({
                    url: artistarena.ajax_url,
                    data: data,
                    type: 'POST',
                    dataType: 'json',
                    beforeSend: function() {
                        wntrTheme.fullpageSpinner(true);
                    },
                    success: function(response) {
                        if(response.success) {
                            if(response.data.action === 'remove') {
                                if(response.data.type === 'profile_picture') {
                                    $.toast({
                                        text: 'Profile picture successfully removed, reloading page..',
                                        bgColor: wntrTheme.successColor,
                                        textColor: '#000000',
                                        position: 'top-right'
                                    });

                                    setTimeout(function() {
                                        window.location.href = artistarena.home_url + '/profile/portfolio?tab=profile_pictures';
                                    }, 500);
                                } else if(response.data.type === 'artwork') {
                                    $.toast({
                                        text: 'Artwork successfully removed, reloading page..',
                                        bgColor: wntrTheme.successColor,
                                        textColor: '#000000',
                                        position: 'top-right'
                                    });

                                    setTimeout(function() {
                                        window.location.href = artistarena.home_url + '/profile/portfolio?tab=artworks';
                                    }, 500);
                                }
                            } else if(response.data.action === 'use') {
                                $.toast({
                                    text: 'Profile picture successfully updated, reloading page..',
                                    bgColor: wntrTheme.successColor,
                                    textColor: '#000000',
                                    position: 'top-right'
                                });

                                setTimeout(function() {
                                    window.location.href = artistarena.home_url + '/profile/portfolio?tab=profile_pictures';
                                }, 500);
                            }
                        } else {
                            $.toast({
                                text: response.data,
                                bgColor: wntrTheme.failColor,
                                textColor: '#000000',
                                position: 'top-right'
                            });

                            wntrTheme.fullpageSpinner(false);
                        }
                    },
                    fail: function() {
                        wntrTheme.fullpageSpinner(false);
                    }
                });
            });

            // Handle artwork names
            wntrTheme.body.on('click', '.ginput_container_artist_images-custom-name button', function() {
                const $btn = $(this);
                const data = {
                    'action': 'update_artist_artwork_name',
                    'data': {
                        'image_url': $btn.closest('.ginput_container_artist_images').data('url'),
                        'name': $btn.closest('.ginput_container_artist_images-custom-name').find('input').val()
                    }
                };

                $.ajax({
                    url: artistarena.ajax_url,
                    data: data,
                    type: 'POST',
                    dataType: 'json',
                    beforeSend: function() {
                        wntrTheme.fullpageSpinner(true);
                    },
                    success: function(response) {
                        if(response.success) {
                            $.toast({
                                text: response.data.msg,
                                bgColor: wntrTheme.successColor,
                                textColor: '#000000',
                                position: 'top-right'
                            });

                            $btn.closest('.ginput_container_artist_images-custom-name').find('input').val(response.data.nice_name);
                        } else {
                            $.toast({
                                text: response.data,
                                bgColor: wntrTheme.failColor,
                                textColor: '#000000',
                                position: 'top-right'
                            });
                        }

                        wntrTheme.fullpageSpinner(false);
                    },
                    fail: function() {
                        wntrTheme.fullpageSpinner(false);
                    }
                });
            });

            // Show fullpage spinner on button click
            /*wntrTheme.body.on('click', '.manage-product__modal input[type="submit"], #submit-product__modal input[type="submit"]', function() {
                const $btn = $(this);
                setTimeout(() => {
                    $btn.closest('.gform_footer').find('img.gform_ajax_spinner').wrap('<div id="wntr__fullpage-spinner" style="display:flex;"></div>');
                });
            });
            wntrTheme.body.on('click', '.dashboard__portfolio-content-inner input[type="submit"], #edit-product input[type="submit"]', function() {
                const $btn = $(this);
                setTimeout(() => {
                    $btn.closest('.gform_wrapper').find('form').append('<div id="wntr__fullpage-spinner" style="display:flex;"><img src="' + (artistarena.get_template_directory_uri + "/src/images/spinner-white.svg") + '" alt="spinner"></div>');
                    $btn.closest('.gform_footer').find('img.gform_ajax_spinner').remove();
                });
            });*/

            // Handle remove buddy
            wntrTheme.body.on('click', '.buddies__action--remove', function() {
                const data = {
                    'action': 'update_buddy_list',
                    'data': {
                        'artist_name': $(this).parents('.buddies__item').data('artist-name')
                    }
                };

                $.ajax({
                    url: artistarena.ajax_url,
                    data: data,
                    type: 'POST',
                    dataType: 'json',
                    beforeSend: function() {
                        wntrTheme.fullpageSpinner(true);
                    },
                    success: function(response) {
                        if(response.success) {
                            $.toast({
                                text: 'Buddy successfully removed, reloading page..',
                                bgColor: wntrTheme.successColor,
                                textColor: '#000000',
                                position: 'top-right'
                            });
                            setTimeout(function() {
                                window.location.href = artistarena.home_url + '/profile?buddies';
                            }, 500);
                            wntrTheme.fullpageSpinner(false);
                        } else {
                            $.toast({
                                text: response.data,
                                bgColor: wntrTheme.failColor,
                                textColor: '#000000',
                                position: 'top-right'
                            });
                            wntrTheme.fullpageSpinner(false);
                        }
                    },
                    fail: function() {
                        wntrTheme.fullpageSpinner(false);
                    }
                });
            });

            // Delete product
            wntrTheme.body.find('.dashboard__store-edit-product-popup-delete-btn').on('click', function() {
                if(confirm('Are you sure you want to delete this product? This can not be undone.')) {
                    const $btn = $(this);

                    const data = {
                        'action': 'delete_product',
                        'data': {
                            'product_id': $btn.data('product-id')
                        }
                    };

                    $.ajax({
                        url: artistarena.ajax_url,
                        data: data,
                        type: 'POST',
                        dataType: 'json',
                        beforeSend: function() {
                            wntrTheme.fullpageSpinner(true);
                        },
                        success: function(response) {
                            if(response.success) {
                                $.toast({
                                    text: 'Product successfully deleted, reloading page..',
                                    bgColor: wntrTheme.successColor,
                                    textColor: '#000000',
                                    position: 'top-right'
                                });

                                setTimeout(function() {
                                    window.location.href = artistarena.home_url + '/profile/store';
                                }, 500);
                            } else {
                                $.toast({
                                    text: 'Error deleting product, please try again.',
                                    bgColor: wntrTheme.failColor,
                                    textColor: '#000000',
                                    position: 'top-right'
                                });

                                wntrTheme.fullpageSpinner(false);
                            }
                        },
                        fail: function() {
                            $.toast({
                                text: 'Error deleting product, please try again.',
                                bgColor: wntrTheme.failColor,
                                textColor: '#000000',
                                position: 'top-right'
                            });

                            wntrTheme.fullpageSpinner(false);
                        }
                    });

                } else {
                    wntrTheme.closeEditProductPopups();
                }
            });

            // Pre populate edit product images
            if(wntrTheme.body.find('#edit-product').length > 0) {
                const $container = wntrTheme.body.find('#edit-product');
                dynamicallyPopulateProductImages($container.data('product-id'), $container);
            }

            // Dynamically populate product images in the edit product form
            function dynamicallyPopulateProductImages(product_id, $container) {
                const data = {
                    'action': 'dynamically_populate_product_images',
                    'data': {
                        'product_id': product_id
                    }
                };

                $.ajax({
                    url: artistarena.ajax_url,
                    data: data,
                    type: 'POST',
                    dataType: 'json',
                    beforeSend: function() {
                        wntrTheme.fullpageSpinner(true);
                    },
                    success: function(response) {
                        if(response.success) {
                            $container.find('.main_product_image .gfield_label').html('Main product image <span style="color: #FF4A4A; font-size: 1.4rem;">(uploading a new main product image will replace the current one).</span>');
                            $container.find('.gallery_images .gfield_label').html('Gallery images <span style="color: #FF4A4A; font-size: 1.4rem;">(uploading new gallery images will replace the current ones).</span>');

                            if(response.data.main_product_image.length > 0) {
                                $container.find('.current_main_product_image').html(
                                    '<div class="ginput_container ginput_container_text ginput_container_artist_images">' +
                                    '<img src="' + response.data.main_product_image + '" alt="">' +
                                    '</div>'
                                );
                            }

                            if(response.data.product_gallery_images.length > 0) {
                                let gallery_images = '';
                                response.data.product_gallery_images.forEach(function(url) {
                                    gallery_images += '<img src="' + url + '" alt="">';
                                });

                                $container.find('.current_product_gallery_images').html(
                                    '<div class="ginput_container ginput_container_text ginput_container_artist_images">' +
                                    gallery_images +
                                    '</div>'
                                );
                            }
                        }

                        wntrTheme.fullpageSpinner(false);
                    },
                    fail: function() {
                        wntrTheme.fullpageSpinner(false);
                    }
                });
            }
        },

        /**
         * Filter profile product table
         */
        __filterProfileProductTable: () => {
            wntrTheme.body.find('#dashboard__store-table-filter').on('change', function() {
                const $filter = $(this);
                const filter_by = $('option:selected', $filter).val();

                wntrTheme.body.find('.dashboard__store-table-filter').removeClass('dashboard__store-table-filter--active');
                $filter.closest('.dashboard__store-table-filter').addClass('dashboard__store-table-filter--active');

                if(filter_by === 'all') {
                    wntrTheme.body.find('#dashboard__store-table tbody tr').show();
                } else {
                    wntrTheme.body.find('#dashboard__store-table tbody tr').hide();
                    wntrTheme.body.find('#dashboard__store-table tbody tr.dashboard__store-table--status-' + filter_by).show();
                }
            });
        },

        /**
         * Preview uploaded images
         */
        __gfPreviewUploadedImages: () => {
            // Preview uploaded images
            if(wntrTheme.body.find('.dashboard__portfolio, .dashboard__store, .page-section-signup, #edit-product').length > 0) {
                gform.addFilter('gform_file_upload_markup', function(html, file, up, strings, imagesUrl, response) {
                    let tempUploadUrl = '';
                    if(wntrTheme.body.find('.dashboard__portfolio-content-inner[data-content="profile_pictures"]').hasClass('active')) {
                        tempUploadUrl = wntrTheme.body.find('.dashboard__portfolio-content-inner[data-content="profile_pictures"]').data('tmp');
                    } else if(wntrTheme.body.find('.dashboard__portfolio-content-inner[data-content="artworks"]').hasClass('active')) {
                        tempUploadUrl = wntrTheme.body.find('.dashboard__portfolio-content-inner[data-content="artworks"]').data('tmp');
                    } else if(wntrTheme.body.find('#submit-product__modal').is(':visible')) {
                        tempUploadUrl = wntrTheme.body.find('#submit-product__modal').data('tmp');
                    } else if(wntrTheme.body.find('#edit-product').length > 0) {
                        tempUploadUrl = wntrTheme.body.find('#edit-product').data('tmp');
                    } else if(wntrTheme.body.find('.page-section-signup #gform_page_1_4').is(':visible')) {
                        tempUploadUrl = wntrTheme.body.find('.page-section-signup .signup').data('tmp');
                    }

                    const formId = up.settings.multipart_params.form_id;
                    const fieldId = up.settings.multipart_params.field_id;
                    html = '<div class="gfupload__preview">'
                        + '<img src="https://artistarena.co/cdn-cgi/image/width=100,dpr=1.5/' + (tempUploadUrl.replace('s3://artistarena', 'https://artistarena.wntr.io') + '/tmp/' + response.data.temp_filename) + '" alt=""/>'
                        + '<strong>' + file.name + "</strong> <button type='button' class='btn--clean btn__delete-gfupload' "
                        + "onclick='gformDeleteUploadedFile(" + formId + "," + fieldId + ", this);' "
                        + "alt='" + strings.delete_file + "' title='" + strings.delete_file + "'></button>"
                        + '</div>';

                    return html;
                });
            }
        },

        /**
         * Handle edit product popup
         */
        __editProductPopup: () => {
            wntrTheme.body.find('.dashboard__store-edit-product').on('click', function() {
                const $btn = $(this);

                if($btn.hasClass('active')) {
                    wntrTheme.closeEditProductPopups();
                } else {
                    wntrTheme.closeEditProductPopups();

                    $btn.addClass('active');
                    $btn.closest('.dashboard__store-edit-product-cell').find('.dashboard__store-edit-product-popup').addClass('active');
                }
            });

            $(document).on('keyup', function(e) {
                if(e.key === 'Escape') {
                    wntrTheme.closeEditProductPopups();
                }
            });
        },

        /**
         * Sort tables
         */
        __sortTables: () => {
            wntrTheme.body.find('#dashboard__store-table th').on('click', function() {
                sortDashboardTable(parseInt($(this).data('num')), 'dashboard__store-table');
            });

            wntrTheme.body.find('#self-billing-invoices__table th').on('click', function() {
                sortDashboardTable(parseInt($(this).data('num')), 'self-billing-invoices__table');
            });

            function sortDashboardTable(n, id) {
                let rows = '';
                let i = '';
                let x = '';
                let y = '';
                let shouldSwitch = '';
                let switchcount = 0;

                const table = document.getElementById(id);
                let switching = true;
                // Set the sorting direction to ascending:
                let dir = "asc";
                /* Make a loop that will continue until
                no switching has been done: */
                while(switching) {
                    // Start by saying: no switching is done:
                    switching = false;
                    rows = table.rows;
                    /* Loop through all table rows (except the
                    first, which contains table headers): */
                    for(i = 1; i < (rows.length - 1); i++) {
                        // Start by saying there should be no switching:
                        shouldSwitch = false;
                        /* Get the two elements you want to compare,
                        one from current row and one from the next: */
                        x = rows[i].getElementsByTagName("TD")[n];
                        y = rows[i + 1].getElementsByTagName("TD")[n];
                        /* Check if the two rows should switch place,
                        based on the direction, asc or desc: */
                        if(dir === "asc") {
                            if(x.innerHTML.toLowerCase() > y.innerHTML.toLowerCase()) {
                                // If so, mark as a switch and break the loop:
                                shouldSwitch = true;
                                break;
                            }
                        } else if(dir === "desc") {
                            if(x.innerHTML.toLowerCase() < y.innerHTML.toLowerCase()) {
                                // If so, mark as a switch and break the loop:
                                shouldSwitch = true;
                                break;
                            }
                        }
                    }
                    if(shouldSwitch) {
                        /* If a switch has been marked, make the switch
                        and mark that a switch has been done: */
                        rows[i].parentNode.insertBefore(rows[i + 1], rows[i]);
                        switching = true;
                        // Each time a switch is done, increase this count by 1:
                        switchcount++;
                    } else if(switchcount === 0 && dir === "asc") {
                        /* If no switching has been done AND the direction is "asc",
                        set the direction to "desc" and run the while loop again. */
                        dir = "desc";
                        switching = true;
                    }
                }
            }
        },

        /**
         * Signup settings
         */
        __signupSettings: () => {
            // Automatically go to next step when selecting a price
            wntrTheme.body.on('click', '.page-section-signup .gfield_price .gchoice label', function() {
                setTimeout(() => {
                    wntrTheme.body.find('.page-section-signup .gform-body .gform_page_footer .gform_next_button').trigger('click');
                });
            });
        },

        /**
         * Gravity forms counter
         */
        __gravityformsWordCounter: () => {
            if(wntrTheme.body.find('.character-count__textarea textarea').length > 0) {
                insertCharacterCount();

                $(document).on('gform_page_loaded', function() {
                    insertCharacterCount();
                });

                wntrTheme.body.on('keyup click blur focus change paste', '.character-count__textarea textarea', function() {
                    const $textarea = $(this);
                    $textarea.closest('.ginput_container').find('.character-count').text($textarea.val().length);
                });
            }

            function insertCharacterCount() {
                const $textareas = wntrTheme.body.find('.character-count__textarea textarea');
                $.each($textareas, function() {
                    const $textarea = $(this);
                    $('<div class="character-count__wrapper"><span class="character-count">' + $textarea.val().length + '</span> / 1500 characters</div>').insertAfter($textarea);
                });
            }

            if(wntrTheme.body.find('.gf-upload-guide').length > 0) {
                moveUploadGuide();

                $(document).on('gform_page_loaded', function() {
                    moveUploadGuide();
                });
            }

            function moveUploadGuide() {
                const $upload_guide = wntrTheme.body.find('.signup__upload-guide');

                if($upload_guide.length > 0) {
                    $upload_guide.clone().appendTo(wntrTheme.body.find('.gf-upload-guide'));
                }
            }
        },

        /**
         * Gravity forms counter
         */
        __aiDescription: () => {
            if(wntrTheme.body.find('.ai-description textarea').length > 0) {
                insertAiDescription();

                $(document).on('gform_page_loaded', function() {
                    insertAiDescription();
                });

                // Enable button when textarea has content
                wntrTheme.body.on('keyup click blur focus change paste', '.character-count__textarea textarea', function() {
                    const $textarea = $(this);

                    if($textarea.val().length > 0) {
                        $textarea.closest('.ginput_container').find('.ai-description__button').prop('disabled', false);
                    } else {
                        $textarea.closest('.ginput_container').find('.ai-description__button').prop('disabled', true);
                    }
                });

                // Rephrase description with AI
                wntrTheme.body.on('click', '.ai-description__button', function() {
                    const $btn = $(this);
                    const modal_id = $btn.data('modal-id');
                    const $modal = wntrTheme.body.find('#' + modal_id);
                    const $modal_loading = $modal.find('.ai-description__modal-loading');
                    const $modal_error = $modal.find('.ai-description__modal-error');
                    const $modal_result = $modal.find('.ai-description__modal-result');
                    const $modal_inner = $modal.find('.ai-description__modal-result-inner');

                    let description = $btn.closest('.ginput_container').find('textarea').val();
                    if($btn.hasClass('ai-description__button--rephrase')) {
                        description = $modal_inner.text();
                    }

                    const data = {
                        'action': 'ai_description',
                        'data': {
                            'description': description,
                            'prompt_type': $btn.data('prompt-type')
                        }
                    };

                    $.ajax({
                        url: artistarena.ajax_url,
                        data: data,
                        type: 'POST',
                        dataType: 'json',
                        beforeSend: function() {
                            $modal_loading.removeClass('ai-description__modal-loading--hidden');
                            $modal_result.removeClass('ai-description__modal-result--visible');
                            $modal_error.removeClass('ai-description__modal-error--visible');
                        },
                        success: function(response) {
                            $modal_loading.addClass('ai-description__modal-loading--hidden');
                            $modal_result.addClass('ai-description__modal-result--visible');
                            $modal_inner.html(response.data.description);
                        },
                        fail: function() {
                            $modal_error.addClass('ai-description__modal-error--visible');
                        }
                    });
                });

                // Accept the rephrased description and close the modal
                wntrTheme.body.on('click', '.ai-description__button--accept', function() {
                    const $btn = $(this);
                    const modal_id = $btn.data('modal-id');
                    const textarea_id = $btn.data('textarea-id');

                    const $modal = wntrTheme.body.find('#' + modal_id);
                    const $textarea = wntrTheme.body.find('#' + textarea_id);

                    $textarea.val($modal.find('.ai-description__modal-result-inner').text());
                    setTimeout(() => {
                        $modal.find('.carousel__button').trigger('click');
                        $textarea.focus();
                    });
                });
            }

            function insertAiDescription() {
                const $textareas = wntrTheme.body.find('.ai-description textarea');
                $.each($textareas, function() {
                    const $textarea = $(this);
                    const id = $textarea.attr('id');
                    const parent_classes = $textarea.closest('.ai-description').attr('class');
                    let prompt_type = 'about';
                    if(parent_classes.includes('ai-description--soi')) {
                        prompt_type = 'soi';
                    } else if(parent_classes.includes('ai-description--product')) {
                        prompt_type = 'product';
                    }

                    $('<div class="ai-description__wrapper">' +
                        '<button class="ai-description__button" data-prompt-type="' + prompt_type + '" disabled data-modal-id="ai-description-' + id + '" data-src="#ai-description-' + id + '" data-fancybox="ai-description-' + id + '" type="button">Rephrase with AI</button>' +
                        '<div class="ai-description__modal" id="ai-description-' + id + '" style="display: none;">' +
                          '<p class="ai-description__modal-loading">Rephrasing, please stay put..</p>' +
                          '<p class="ai-description__modal-error">Something went wrong, please close this popup and try again!</p>' +
                          '<div class="ai-description__modal-result">' +
                            '<div class="ai-description__modal-result-inner">' +
                            '</div>' +
                            '<div class="ai-description__modal-result-actions">' +
                              '<button class="ai-description__button--accept" type="button" data-modal-id="ai-description-' + id + '" data-textarea-id="' + id + '">Accept</button>' +
                              '<button class="ai-description__button ai-description__button--rephrase" data-modal-id="ai-description-' + id + '" data-prompt-type="' + prompt_type + '" type="button">Rephrase again</button>' +
                            '</div>' +
                          '</div>' +
                        '</div>' +
                      '</div>').insertAfter($textarea);
                });
            }
        },

        /**
         * Toggle search page tabs
         */
        __toggleSearchPageTabs: function() {
            const $search_tab = wntrTheme.body.find('.search__results-tab');

            $search_tab.on('click', function() {
                wntrTheme.body.find('.search__results-tab').removeClass('is-active');
                wntrTheme.body.find('.search__result').removeClass('is-active');

                $(this).addClass('is-active');
                wntrTheme.body.find('.search__result--' + $(this).data('tab')).addClass('is-active');
            });
        },

        /**
         * Gravity forms price counter
         */
        __gravityformsPriceCounter: () => {
            if(wntrTheme.body.find('.product_price input').length > 0) {
                // 20% provision
                const provision = 0.2;
                // 1.85% stripe fee
                const stripe_fee = 0.0185;
                // exchange rate
                let exchange_rate = 11; // fallback value
                const $profileDashboard = wntrTheme.body.find('#profile-dashboard');
                if ($profileDashboard.length > 0 && $profileDashboard.data('exchange-rate')) {
                    exchange_rate = parseFloat($profileDashboard.data('exchange-rate'));
                }

                insertProvisionCounter(provision, stripe_fee, exchange_rate);

                $(document).on('gform_page_loaded', function() {
                    insertProvisionCounter(provision, stripe_fee, exchange_rate);
                });

                wntrTheme.body.on('keyup click blur focus change paste', '.product_price input', function() {
                    const $input = $(this);
                    const price = parseFloat($input.val());
                    let artist_price = 0;
                    let artist_price_sek = 0;
                    if(!Number.isNaN(price)) {
                        artist_price = price - (price * provision - price * stripe_fee);
                        artist_price_sek = Math.round(price * exchange_rate);
                    }
                    $input.closest('.ginput_container').find('.price-count').text('~' + artist_price.toFixed(2));
                    $input.closest('.ginput_container').find('.price-count-sek').text(artist_price_sek.toFixed(2));
                });
            }

            function insertProvisionCounter(provision, stripe_fee, exchange_rate) {
                const $inputs = wntrTheme.body.find('.product_price input');
                $.each($inputs, function() {
                    const $input = $(this);
                    const price = parseFloat($input.val());
                    let artist_price = 0;
                    let artist_price_sek = 0;
                    if(!Number.isNaN(price)) {
                        artist_price = price - (price * provision - price * stripe_fee);
                        artist_price_sek = Math.round(price * exchange_rate);
                    }
                    $('<div class="price-count__wrapper">You will receive: <span class="price-count">~' + artist_price.toFixed(2) + '</span> € | <span class="price-count-sek__wrapper">Price in sek: <span class="price-count-sek">' + artist_price_sek.toFixed(2) + '</span></span><p>The artist will receive 80% of the sales price minus the transaction cost. Transaction cost is generally around 1,85% of total sales.</p><p>NOTE: Artist is responsible for shipping costs to the client. Shipping cost should therefore also be taken into account when setting the price. In case of returns, return shipping is on the client’s account. </p></div>').insertAfter($input);
                });
            }
        },

        __triggerPriceFilterOnEnterClick: () => {
            wntrTheme.body.on('keydown', '.wcpf-min-input, .wcpf-max-input', function (e) {
                if (e.key === 'Enter') {
                    $(this).blur();
                    $(this).trigger('change');
                }
            });
        },

        /**
         * Fullpage spinner
         */
        fullpageSpinner: (visible) => {
            if(visible) {
                wntrTheme.body.find('#wntr__fullpage-spinner').css('display', 'flex');
            } else {
                wntrTheme.body.find('#wntr__fullpage-spinner').css('display', 'none');
            }
        },

        /**
         * Close edit product popups
         */
        closeEditProductPopups: () => {
            wntrTheme.body.find('.dashboard__store-edit-product-popup').removeClass('active');
            wntrTheme.body.find('.dashboard__store-edit-product').removeClass('active');
        },

        /**
         * Listen to signup form step change
         */
        __signupFormStepChange: () => {
            window.addEventListener('message', (e) => {
                const key = e.message ? 'message' : 'data';
                const data = e[key];

                if(data.message && data.message === 'signup_form_step_changed') {
                    if(data.current_page_number && data.current_page_number === 1) {
                        wntrTheme.body.find('.page-section:not(#page-section-1)').show();
                    } else {
                        wntrTheme.body.find('.page-section:not(#page-section-1)').hide();
                    }
                }
            }, false);
        },

        __handleProductStarClick: () => {
            wntrTheme.body.on('click', '.product-star', function() {
                const productId = $(this).data('product-id');
                let likedProducts = wntrTheme.getCookie('likedProducts');

                if(likedProducts) {
                    likedProducts = likedProducts.split(',');
                } else {
                    likedProducts = [];
                }

                const index = likedProducts.indexOf(productId.toString());

                if(index > -1) {
                    // Product is already liked, remove it
                    likedProducts.splice(index, 1);
                    wntrTheme.updateProductLikes(productId, 'decrement', $(this));
                } else {
                    // Product is not liked, add it
                    likedProducts.push(productId);
                    wntrTheme.updateProductLikes(productId, 'increment', $(this));
                }

                // Set the cookie with updated liked products
                wntrTheme.setCookie('likedProducts', likedProducts.join(','), 365 * 10); // Set cookie for 10 years
            });
        },

        __fbTracking: () => {
            if(typeof fbq !== 'undefined') {
                // View content
                if(wntrTheme.body.hasClass('single-product')) {
                    const product = wntrTheme.body.find('#shop-single-product');
                    fbq('track', 'ViewContent', {
                        content_ids: product.data('product-id') ? [product.data('product-id').toString()] : '',
                        content_type: 'product',
                        value: product.data('product-price') ? parseFloat(product.data('product-price')) : 0,
                        currency: 'EUR'
                    });
                }

                // Initiating checkout
                jQuery('body').on('init_checkout', function() {
                    const product = wntrTheme.body.find('.woocommerce-mini-cart-item').first();
                    fbq('track', 'InitiateCheckout', {
                        content_ids: product.data('product-id') ? [product.data('product-id').toString()] : '',
                        content_type: 'product',
                        value: product.data('product-price') ? parseFloat(product.data('product-price')) : 0,
                        currency: 'EUR'
                    });
                });

                // Purchase
                if (window.location.pathname.includes('/checkout/order-received')) {
                    const product = wntrTheme.body.find('.order_item').first();
                    fbq('track', 'Purchase', {
                        content_ids: product.data('product-id') ? [product.data('product-id').toString()] : '',
                        content_type: 'product',
                        value: product.data('product-price') ? parseFloat(product.data('product-price')) : 0,
                        currency: 'EUR'
                    });
                }
            }
        },

        updateProductLikes: (productId, action, $btn) => {
            const data = {
                'action': 'update_product_likes',
                'data': {
                    'product_id': productId,
                    'action': action
                }
            };

            $.ajax({
                url: artistarena.ajax_url,
                data: data,
                type: 'POST',
                dataType: 'json',
                beforeSend: function() {
                    $btn.addClass('product-star--loading');
                },
                success: function(response) {
                    if(response.success) {
                        if(action === 'increment') {
                            $btn.addClass('product-star--liked');
                        } else {
                            $btn.removeClass('product-star--liked');
                        }
                    } else {
                        $btn.removeClass('product-star--liked');
                    }

                    $btn.removeClass('product-star--loading');
                },
                fail: function() {
                    $btn.removeClass('product-star--loading');
                }
            });
        },

        setCookie: (name, value, days) => {
            let expires = "";
            if(days) {
                const date = new Date();
                date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
                expires = "; expires=" + date.toUTCString();
            }
            document.cookie = name + "=" + (value || "") + expires + "; path=/";
        },

        getCookie: (name) => {
            const nameEQ = name + "=";
            const ca = document.cookie.split(';');
            for(let i = 0; i < ca.length; i++) {
                let c = ca[i];
                while(c.charAt(0) == ' ') c = c.substring(1, c.length);
                if(c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
            }
            return null;
        },

        eraseCookie: (name) => {
            document.cookie = name + '=; Max-Age=-99999999;';
        }
    };

    $(document).ready(wntrTheme.init);
})(jQuery);